
<div>
    <v-hover v-slot="{ hover }" open-delay="200">
        <div>
            <v-expand-transition>
                <crm-entry-menu
                    :entry    = "entry"
                    v-if      = "hover"
                    @edit     = "onEdit"
                    @delete   = "onDelete"
                    @undelete = "onUndelete"
                />
            </v-expand-transition>

            <div class="card-info-title crm-title" style="justify-content: space-between">
                <div class="v-flex">
                    <v-icon
                        v-if="entry.type.font"
                        class  = "crm-journal-icon"
                        :class = "titleTextColor"
                    >
                        {{ entry.type.font }} {{ 'fa-' + entry.type.symbol }}
                    </v-icon>
                    <v-icon
                        v-if="!entry.type.font"
                        class  = "crm-journal-mdi-icon"
                        :class = "titleTextColor"
                        :size   = "20"
                    >
                        {{ entry.type.symbol }}
                    </v-icon>
                    <div
                        class  = "card-info-text crm-date"
                        :class = "textColor"
                    >
                        {{ dateAsString (entry.time !== null ? entry.time : entry.createdDate) }}
                    </div>
                </div>
                <div
                    class  = "crm-avatar"
                    :class = "textColor"
                >
                    {{ dateAsString(entry.modifiedDate) + " - " + (entry.modifiedBy ? entry.modifiedBy : entry.user ? entry.user.ident : '') }}
                </div>
            </div>

            <div
                class  = "card-info-text crm-subtitle"
                :class = "titleTextColor"
            >
                {{ subject }}
            </div>

            <div class="v-flex"  v-if="entry.partner.name">
                <v-icon
                    class="crm-journal-icon"
                    :class = "textColor"
                >
                    fas fa-user-tie
                </v-icon>
                <div
                    class="card-info-text crm-partner"
                    :class = "textColor"
                >
                    {{ entry.partner.name }}
                </div>
            </div>

            <div
                class="card-info-text crm-email"
                :class = "textColor"
            >
                {{ entry.partner.email }}
            </div>

            <div
                class  = "card-info-text crm-description"
                :class = "entry.deleted?'red--text':''"
                v-html = "entry.description"
            >
            </div>
        </div>
    </v-hover>
</div>
